import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  background: (p) => p.palette.common.white,
  padding: (p) => p.spacing(1, 1.5),
  pr: 3.5,
  '.Mui-selected': {
    p: {
      fontWeight: (p) => p.typography.fontWeightBold,
    },
    '.MuiTypography-root': {
      fontWeight: (p) => p.typography.fontWeightBold,
    },
  },
};

export const tabList: SxStyle = {
  borderBottom: (p) => `1px solid ${p.palette.grey[300]}`,
  paddingTop: (p) => p.spacing(1),
  paddingRight: (p) => p.spacing(3),
};
